import type { KrcAgeRangeItemNode, KrcGoalSetItemNode } from '@newStore/documentUI/documentUITypes';

type KrcItemNode = KrcGoalSetItemNode | KrcAgeRangeItemNode;

const KrcItemRow: React.FC<{ contentNode: KrcItemNode }> = ({ contentNode }) => {
  if (!contentNode.title && contentNode.type === 'KRC_GOAL_SET_ITEM') {
    return <div>Doelenset niet gevonden.</div>;
  }
  if (!contentNode.title && contentNode.type === 'KRC_AGE_RANGE_ITEM') {
    return <div>Leeftijdsbereik niet gevonden.</div>;
  }

  return (
    <div>
      {contentNode.identifier && <span>{contentNode.identifier} </span>}
      <span>{contentNode.title}</span>
    </div>
  );
};

export default KrcItemRow;
